export const LANGS = [
  { code: "fr", label: "FR", name: "Français" },
  { code: "en", label: "EN", name: "English" },
  { code: "pt", label: "PT", name: "Português" },
];

export const translations = {
  fr: {
    nav: { features: "Fonctionnalités", preview: "Aperçu", demo: "Démo", byok: "Tutoriel IA", pricing: "Tarifs", faq: "FAQ", launch: "Lancer l'app" },
    hero: {
      badge: "Disponible en test sur iOS & Android",
      titleA: "Ton compagnon",
      titleHighlight: "santé & nutrition",
      titleB: "au quotidien.",
      subtitle:
        "Suivi glycémie précis, journal nutritionnel avec IA, bien-être féminin, partage de tes résultats avec un coach nutritionnel et centre santé unifié — tout ça dans une seule app pensée pour la vraie vie.",
      local: "100% local, tes données ne quittent pas ton téléphone",
    },
    store: {
      iosSub: "Version de test · iOS", iosLabel: "Rejoindre TestFlight",
      androidSub: "Version de test · Android", androidLabel: "Test interne Play",
      placesLimited: "Places limitées", onInvitation: "Sur invitation",
    },
    stats: [
      { value: "30 000+", label: "aliments FR indexés" },
      { value: "100%", label: "local · privacy first" },
      { value: "7", label: "modules intégrés" },
      { value: "4.8★", label: "note utilisateurs" },
    ],
    features: {
      overline: "Fonctionnalités",
      title: "Votre santé. Une seule application.",
      subtitle:
        "Jos'FIT centralise tout ce dont vous avez besoin pour mieux comprendre votre santé et atteindre vos objectifs.",
      items: [
        { title: "Nutrition intelligente", items: ["Journal alimentaire ultra rapide", "Plus de 4 millions d'aliments", "Base CIQUAL prioritaire", "Photo IA de vos plats · analyse optimisée", "Scan de code-barres & saisie vocale", "Création & import de recettes par IA", "Calcul auto des calories & macros"] },
        { title: "Coach IA intégré", items: ["Analyse de vos repas", "Conseils nutritionnels personnalisés", "Réponses à vos questions santé", "Suggestions adaptées à vos objectifs"] },
        { title: "Cockpit métabolique", items: ["Calories consommées & restantes", "Répartition protéines / glucides / lipides", "IMC & métabolisme basal", "Dépense énergétique", "Suivi des objectifs"] },
        { title: "Suivi corporel", items: ["Évolution du poids", "Photos avant / après", "Mensurations", "Graphiques de progression", "Historique complet"] },
        { title: "Santé métabolique", items: ["Suivi glycémique", "Analyse des tendances", "Corrélation alimentation / glycémie", "Tableau de bord dédié"] },
        { title: "Luna — bien-être féminin", items: ["Suivi du cycle menstruel", "Symptômes & phases du cycle", "Conseils personnalisés"] },
        { title: "Synchronisation santé", items: ["Apple Health", "Health Connect (Android)", "Montres connectées compatibles"] },
        { title: "Courses intelligentes", items: ["Activez le mode course avec vos aliments choisis depuis votre journal", "Liste de courses générée automatiquement", "Classement par rayon"] },
        { title: "Export des données", items: ["Export PDF & CSV", "Sauvegarde locale", "Contrôle total de vos données"] },
        { title: "Confidentialité", items: ["Respect du RGPD", "Données sécurisées & locales", "Contrôle par l'utilisateur", "Aucune publicité"] },
      ],
    },
    steps: {
      overline: "Simple d'utilisation",
      title: "Ton parcours en 3 étapes.",
      items: [
        { title: "Télécharge et installe", desc: "Gratuit sur App Store et Google Play. Aucun compte requis pour démarrer, aucune carte bleue." },
        { title: "Configure en 2 minutes", desc: "Objectifs (poids, calories, macros), profil santé et connexion optionnelle à ta montre connectée." },
        { title: "Vis simplement", desc: "Suis tes repas et ta glycémie. L'app apprend, se personnalise et devient ton copilote santé au fil des jours." },
      ],
    },
    preview: {
      overline: "Aperçu",
      title: "Une interface conçue pour la vraie vie.",
      subtitle: "Chaque écran a été pensé pour te faire gagner du temps et te motiver à long terme. Voici de vrais écrans de l'app.",
      screens: [
        { title: "Suivi coaching", desc: "Raccourcis à partager avec ton coach : PDF du jour, semaine, progression & export CSV" },
        { title: "Recherche d'aliments", desc: "Suggestions IA, index & charge glycémiques, 4M+ aliments" },
        { title: "Ajout intelligent", desc: "Scanner, Photo IA, Vocal ou saisie manuelle" },
        { title: "Repas surprise", desc: "Idée de repas aléatoire selon tes macros" },
        { title: "Journée & Luna IA", desc: "Prédicteur d'envies, conseils cycle & coach Luna" },
        { title: "Dupliquer un repas", desc: "Copie une journée ou un repas en un tap" },
        { title: "Export PDF", desc: "Rapport détaillé jour ou semaine (7 jours)" },
        { title: "Recettes & Import IA", desc: "Découvre, crée et importe une fiche par photo" },
        { title: "Score santé", desc: "Cockpit métabolique, scores nutrition, fibres, sucre" },
        { title: "Bilan métabolique", desc: "BMR, TDEE, IMC, tendance & projection de poids" },
        { title: "Corps", desc: "Mensurations, objectif poids & indices de composition" },
        { title: "Bilan du mois", desc: "Jours suivis, courbe de poids & hydratation" },
        { title: "Bien-être féminin", desc: "Cycle, phases, ovulation, ménopause & rappels" },
        { title: "Ma progression", desc: "Avant / Maintenant, et évolution partageable" },
        { title: "Coach sportif", desc: "Ta prochaine séance, suivi corporel & motivation du jour" },
        { title: "Programmes d'entraînement", desc: "Prise de muscle, perte de gras, poids du corps & routines" },
        { title: "Conseils alimentation", desc: "Fiches protéines, lipides, glucides, fibres & équilibre" },
        { title: "Rappels d'entraînement", desc: "Jours de séance & heure — un rappel doux pour rester régulier" },
        { title: "Séance guidée", desc: "Exercice détaillé, séries, charges & vidéo technique" },
        { title: "Minuteur de repos", desc: "Temps de repos entre séries, ±15s & conseils" },
      ],
    },
    video: {
      overline: "Démo", title: "Vois l'app en action.",
      subtitle: "45 secondes pour comprendre comment Jos'FIT change ton quotidien.",
      badge: "Vidéo démo — bientôt disponible",
      comingSoon: "La vidéo de démonstration arrive très bientôt. Reste connecté·e ! 🎬",
    },
    scanFridge: {
      overline: "Fonctionnalité phare",
      title: "Scanne ton frigo, l'IA fait le reste.",
      subtitle: "Prends ton frigo (ou tes placards) en photo : Jos'FIT identifie tes aliments et te propose instantanément des repas équilibrés adaptés à tes objectifs.",
      bullets: ["Détection instantanée des aliments par IA", "Idées de repas selon ce que tu as vraiment", "Génère ton menu sur 7 jours", "Exporte ton menu en PDF", "Zéro gaspillage, courses optimisées", "Ajout direct à ton journal alimentaire"],
      premium: "Génération de menu sur 7 jours & export PDF disponibles avec l'offre Premium (dès 1,20 €/mois)",
      cta: "Tester le scan frigo",
    },
    byok: {
      overline: "Tutoriel · Clé IA",
      title: "Active l'IA avec ta propre clé Gemini (BYOK).",
      subtitle: "Utilise ta clé Google Gemini personnelle pour débloquer le Coach IA. Suis ce pas-à-pas, c'est fait en 2 minutes.",
      freeBadge: "100% gratuite",
      personalBadge: "Personnelle & privée",
      steps: [
        { title: "Ouvre Google AI Studio", desc: "Rends-toi sur aistudio.google.com/app/apikey et connecte-toi avec ton compte Google." },
        { title: "Crée ta clé API", desc: "Clique sur « Create API key » (Créer une clé API), puis choisis un projet ou laisse le projet par défaut." },
        { title: "Copie ta clé", desc: "Ta clé Gemini apparaît (elle commence par AIza…). Copie-la en un seul clic." },
        { title: "Colle-la dans Jos'FIT", desc: "Ouvre Profil → Premium BYOK, colle ta clé et valide." },
        { title: "C'est prêt !", desc: "Le Coach IA Luna, l'analyse photo et les conseils personnalisés sont débloqués." },
      ],
      step: "Étape",
      note: "Ta clé Gemini est gratuite (quota offert par Google) et strictement personnelle : elle reste sur ton appareil, Jos'FIT ne la stocke jamais sur ses serveurs.",
      cta: "Obtenir ma clé Gemini gratuite",
    },
    pricing: {
      overline: "Tarifs",
      slogan: "Le suivi santé qui s'adapte à toi, pas l'inverse.",
      subtitle: "Trois offres claires, sans engagement. Commence gratuitement, passe au Premium quand tu veux.",
      perMonth: "/mois",
      perYear: "/an",
      billing: { monthly: "Mensuel", annual: "Annuel", save: "2 mois offerts" },
      guarantee: "Sans engagement · Résiliable à tout moment · Aucune donnée revendue",
      popular: "La plus populaire",
      plans: [
        {
          emoji: "🌱",
          name: "Gratuit",
          price: "0 €",
          priceAnnual: "0 €",
          annualEq: "",
          priceNote: "sans engagement, sans carte bancaire",
          tagline: "Suivi manuel essentiel. Parce que la santé n'a pas de prix.",
          features: [
            "Recherche dans 6 000+ aliments (dispo hors-ligne)",
            "Tracking macros (protéines, glucides, lipides, fibres) + calories",
            "Journal repas quotidien (petit-déj, déjeuner, dîner, snack)",
            "Suivi glycémie complet (mesures, tendances, alertes hypo/hyper)",
            "Calculateur d'entretien (BMR + TDEE)",
          ],
          cta: "Commencer gratuitement",
        },
        {
          emoji: "💎",
          name: "Premium BYOK",
          price: "1,20 €",
          priceAnnual: "12 €",
          annualEq: "soit 1 €/mois",
          priceNote: "sans engagement",
          badge: "Meilleur rapport",
          tagline: "Toutes les fonctions Premium à petit prix, en utilisant ta propre clé IA Google Gemini (gratuite chez Google — 1 500 requêtes/jour).",
          includes: "Tout le Gratuit, plus :",
          features: [
            "Photo IA → analyse auto de ton repas (macros + Nutri-Score + IG)",
            "Analyse IA texte (décris ton repas → l'IA calcule)",
            "Coach Luna : chat IA nutrition & entraînement 24/7",
            "Import recette IA (photo d'une recette → journal instantané)",
            "Cockpit métabolique en temps réel",
            "Liste de courses intelligente",
            "Exports PDF (jour, semaine, rapports médecin AGP)",
            "Suivi du cycle menstruel + phases hormonales",
            "Fiches d'exercices premium (Fiche 36 & +)",
          ],
          note: "Tu configures ta clé Gemini une seule fois (guide 2 min inclus) → tu restes sur ton quota gratuit Google, jamais de surprise.",
          cta: "Passer au Premium BYOK",
        },
        {
          emoji: "👑",
          name: "Premium Clé en main",
          price: "3,99 €",
          priceAnnual: "39,90 €",
          annualEq: "soit 3,32 €/mois",
          priceNote: "sans engagement",
          badge: "Zéro config",
          tagline: "L'expérience la plus simple : tu paies, ça marche. Notre clé IA incluse, aucun setup.",
          includes: "Tout le Premium BYOK, plus :",
          features: [
            "Notre clé Gemini directement intégrée (zéro configuration)",
            "Aucun compte Google AI à créer, aucune manipulation",
            "Support prioritaire par email (réponse < 24 h)",
            "Accès anticipé aux nouvelles fonctions IA",
          ],
          note: "Pour celles et ceux qui veulent juste que ça marche.",
          cta: "Passer au Premium Clé en main",
        },
      ],
      compareTitle: "Comparatif détaillé",
      compareCols: ["Fonctionnalité", "Gratuit", "BYOK · 1,20 €", "Premium · 3,99 €"],
      compareRows: [
        { label: "Base 6 000+ aliments (hors-ligne)", tiers: [true, true, true] },
        { label: "Tracking macros + calories", tiers: [true, true, true] },
        { label: "Journal repas quotidien", tiers: [true, true, true] },
        { label: "Suivi glycémie complet", tiers: [true, true, true] },
        { label: "Calculateur BMR + TDEE", tiers: [true, true, true] },
        { label: "Photo IA (analyse de repas)", tiers: [false, true, true] },
        { label: "Analyse IA texte", tiers: [false, true, true] },
        { label: "Coach Luna (chat IA 24/7)", tiers: [false, true, true] },
        { label: "Import recette IA", tiers: [false, true, true] },
        { label: "Cockpit métabolique temps réel", tiers: [false, true, true] },
        { label: "Liste de courses intelligente", tiers: [false, true, true] },
        { label: "Exports PDF (jour, semaine, AGP médecin)", tiers: [false, true, true] },
        { label: "Suivi cycle menstruel + phases", tiers: [false, true, true] },
        { label: "Fiches d'exercices premium", tiers: [false, true, true] },
        { label: "Clé Gemini incluse (zéro config)", tiers: [false, false, true] },
        { label: "Aucun compte Google AI à créer", tiers: [false, false, true] },
        { label: "Support prioritaire < 24 h", tiers: [false, false, true] },
        { label: "Accès anticipé nouvelles fonctions IA", tiers: [false, false, true] },
      ],
    },
    testimonials: {
      overline: "Ils en parlent", title: "Ce qu'en pensent les utilisateurs.",
      items: [
        { quote: "Enfin une app qui comprend qu'on n'est pas juste des chiffres. Le suivi glycémie avec contexte a changé ma vie.", role: "Diabétique type 1" },
        { quote: "Les macros, l'hydratation, le sport — tout est là. Interface propre et rapide, aucune pub.", role: "Coureur amateur" },
        { quote: "Le module féminin est incroyable. Les corrélations entre cycle et nutrition, je n'avais jamais vu ça ailleurs.", role: "Utilisatrice cycle" },
      ],
    },
    why: {
      overline: "Pourquoi Jos'FIT ?", title: "La différence Jos'FIT.",
      reasons: [
        { title: "Tout-en-un", desc: "Nutrition, santé métabolique et suivi corporel réunis dans une seule application." },
        { title: "Expérience premium", desc: "Simple, rapide et accessible — pensée pour être utilisée chaque jour sans friction." },
        { title: "IA personnalisée", desc: "Des recommandations sur-mesure grâce à l'intelligence artificielle intégrée." },
      ],
      free: "Gratuit", premium: "Premium dès 1,20 €/mois",
      pricingText: "Application gratuite avec les fonctions essentielles. Débloquez l'IA et les analyses avancées avec un abonnement Premium à partir de 1,20 €/mois.",
      cta: "Tester l'application sans installation",
    },
    faq: {
      overline: "FAQ", title: "Questions fréquentes.",
      items: [
        { q: "L'application est-elle vraiment gratuite ?", a: "Oui, toutes les fonctionnalités essentielles sont gratuites et le resteront. Aucune publicité, aucune revente de données. Un pack Premium (facultatif) vous permet de débloquer des fonctionnalités avancées tel que des exports avancés et des analyses IA approfondies." },
        { q: "Mes données santé sont-elles protégées ?", a: "Absolument. Jos'FIT fonctionne 100% en local : tes données restent sur ton téléphone et ne sont jamais envoyées sur un serveur sans ton consentement explicite. La confidentialité est au cœur de l'app." },
        { q: "Puis-je synchroniser ma montre connectée ?", a: "Oui. Jos'FIT se connecte à Health Connect, Apple Santé ainsi qu'aux montres Garmin, Fitbit et Polar pour centraliser toutes tes données au même endroit." },
        { q: "L'application marche-t-elle hors ligne ?", a: "Oui, la majorité des fonctions (journal alimentaire, glycémie, cycle, statistiques) sont disponibles hors ligne. La synchronisation optionnelle se fait dès que tu retrouves une connexion." },
        { q: "Y a-t-il une version web ?", a: "Jos'FIT est avant tout une app mobile iOS & Android pour rester avec toi au quotidien. Une version web complémentaire est à l'étude pour consulter tes rapports." },
        { q: "La clé Google Gemini est-elle vraiment gratuite ?", a: "Oui, à 100 %. Google t'offre jusqu'à 1 500 requêtes par jour gratuitement — largement suffisant pour un usage quotidien. Avec l'offre BYOK, tu utilises ce quota gratuit : tu ne paies que les 1,20 €/mois de Jos'FIT, jamais Google." },
        { q: "Quelle différence entre BYOK et Clé en main ?", a: "Avec BYOK (1,20 €), tu configures ta propre clé Gemini une seule fois (2 min, guide inclus dans l'app). Avec Clé en main (3,99 €), notre clé est déjà intégrée : zéro configuration, tu paies et ça marche." },
        { q: "Puis-je changer d'offre ou résilier à tout moment ?", a: "Bien sûr. Toutes nos offres sont sans engagement. Tu peux passer d'une offre à l'autre ou résilier quand tu veux, directement depuis l'app." },
        { q: "Que se passe-t-il si je dépasse mon quota Gemini gratuit ?", a: "C'est très rare : 1 500 requêtes/jour couvrent un usage intensif. Si jamais tu atteins la limite, l'IA se met simplement en pause jusqu'au lendemain — le reste de l'app continue de fonctionner normalement." },
      ],
    },
    download: {
      title: "Prêt·e à reprendre le contrôle de ta santé ?",
      subtitle: "Téléchargement gratuit. Aucune carte bleue. Aucune pub. Juste toi et tes objectifs.",
    },
    footer: {
      tagline: "Ton compagnon santé & nutrition. Fait avec ❤️ en France.",
      newsTitle: "Reste informé·e", newsDesc: "Reçois nos conseils santé, nutrition & les nouveautés de l'app.",
      placeholder: "Ton adresse email", subscribe: "S'abonner",
      privacy: "Confidentialité", cgu: "CGU", rights: "Tous droits réservés",
      subOk: "Inscription réussie ! Merci de nous rejoindre. 🎉", subErr: "Une erreur est survenue. Réessaie.",
    },
    launch: {
      limitTitle: "Limite d'essai atteinte",
      limitDesc: "Tu as utilisé tes 2 essais gratuits de la preview. Pour continuer à explorer Jos'FIT, rejoins les testeurs officiels 👇",
      expiredTitle: "Temps d'essai écoulé",
      expiredRemaining: "Ton essai de 3 minutes est terminé. Il te reste {n} essai(s). Pour un accès complet, deviens testeur :",
      expiredNone: "Ton essai de 3 minutes est terminé et tu as utilisé tous tes essais gratuits. Deviens testeur pour un accès complet :",
      testflight: "Rejoindre TestFlight (iOS)", android: "Test interne Android (sur invitation)", contact: "Me contacter : contact@josfit.app",
      inProgress: "Essai en cours", popup: "Autorise les pop-ups pour lancer l'application.",
      launched: "Essai lancé (3 min) · Il te reste {n} essai(s)",
    },
  },

  en: {
    nav: { features: "Features", preview: "Preview", demo: "Demo", byok: "AI setup", pricing: "Pricing", faq: "FAQ", launch: "Launch app" },
    hero: {
      badge: "Now in beta on iOS & Android",
      titleA: "Your daily", titleHighlight: "health & nutrition", titleB: "companion.",
      subtitle:
        "Accurate glucose tracking, AI nutrition journal, women's wellness, share your results with a nutrition coach, and a unified health hub — all in one app built for real life.",
      local: "100% local, your data never leaves your phone",
    },
    store: {
      iosSub: "Beta · iOS", iosLabel: "Join TestFlight",
      androidSub: "Beta · Android", androidLabel: "Play internal test",
      placesLimited: "Limited spots", onInvitation: "By invitation",
    },
    stats: [
      { value: "30,000+", label: "foods indexed" },
      { value: "100%", label: "local · privacy first" },
      { value: "7", label: "built-in modules" },
      { value: "4.8★", label: "user rating" },
    ],
    features: {
      overline: "Features",
      title: "Your health. One single app.",
      subtitle: "Jos'FIT brings together everything you need to better understand your health and reach your goals.",
      items: [
        { title: "Smart nutrition", items: ["Ultra-fast food journal", "Over 4 million foods", "CIQUAL database priority", "AI photo of your meals · optimized analysis", "Barcode scan & voice input", "AI recipe creation & import", "Automatic calorie & macro count"] },
        { title: "Built-in AI coach", items: ["Meal analysis", "Personalized nutrition advice", "Answers to your health questions", "Suggestions tailored to your goals"] },
        { title: "Metabolic cockpit", items: ["Calories consumed & remaining", "Protein / carbs / fat breakdown", "BMI & basal metabolism", "Energy expenditure", "Goal tracking"] },
        { title: "Body tracking", items: ["Weight evolution", "Before / after photos", "Measurements", "Progress charts", "Full history"] },
        { title: "Metabolic health", items: ["Glucose tracking", "Trend analysis", "Food / glucose correlation", "Dedicated dashboard"] },
        { title: "Luna — women's wellness", items: ["Menstrual cycle tracking", "Symptoms & cycle phases", "Personalized advice"] },
        { title: "Health sync", items: ["Apple Health", "Health Connect (Android)", "Compatible smartwatches"] },
        { title: "Smart shopping", items: ["Enable shopping mode with foods chosen from your journal", "Automatically generated shopping list", "Sorted by aisle"] },
        { title: "Data export", items: ["PDF & CSV export", "Local backup", "Full control of your data"] },
        { title: "Privacy", items: ["GDPR compliant", "Secure & local data", "User-controlled", "No ads"] },
      ],
    },
    steps: {
      overline: "Easy to use", title: "Your journey in 3 steps.",
      items: [
        { title: "Download & install", desc: "Free on the App Store and Google Play. No account needed to start, no credit card." },
        { title: "Set up in 2 minutes", desc: "Goals (weight, calories, macros), health profile and optional smartwatch connection." },
        { title: "Just live", desc: "Log your meals and glucose. The app learns, personalizes and becomes your daily health copilot." },
      ],
    },
    preview: {
      overline: "Preview", title: "An interface designed for real life.",
      subtitle: "Every screen is built to save you time and keep you motivated long-term. These are real app screens.",
      screens: [
        { title: "Coaching sharing", desc: "Shortcuts to share with your coach: daily & weekly PDF, progress & CSV export" },
        { title: "Food search", desc: "AI suggestions, glycemic index & load, 4M+ foods" },
        { title: "Smart add", desc: "Scan, AI Photo, Voice or manual input" },
        { title: "Surprise meal", desc: "Random meal idea based on your macros" },
        { title: "Day & Luna AI", desc: "Cravings predictor, cycle tips & Luna coach" },
        { title: "Duplicate a meal", desc: "Copy a day or a meal in one tap" },
        { title: "PDF export", desc: "Detailed daily or weekly (7-day) report" },
        { title: "Recipes & AI import", desc: "Discover, create and import a recipe by photo" },
        { title: "Health score", desc: "Metabolic cockpit, nutrition, fiber, sugar scores" },
        { title: "Metabolic report", desc: "BMR, TDEE, BMI, trend & weight projection" },
        { title: "Body", desc: "Measurements, weight goal & composition indices" },
        { title: "Monthly report", desc: "Days tracked, weight curve & hydration" },
        { title: "Women's wellness", desc: "Cycle, phases, ovulation, menopause & reminders" },
        { title: "My progress", desc: "Before / After, and shareable evolution" },
        { title: "Sport coach", desc: "Your next session, body tracking & daily motivation" },
        { title: "Workout programs", desc: "Muscle gain, fat loss, bodyweight & saved routines" },
        { title: "Nutrition tips", desc: "Protein, fat, carb & fiber sheets & balance" },
        { title: "Workout reminders", desc: "Training days & time — a gentle nudge to stay consistent" },
        { title: "Guided workout", desc: "Detailed exercise, sets, loads & technique video" },
        { title: "Rest timer", desc: "Rest between sets, ±15s & tips" },
      ],
    },
    video: {
      overline: "Demo", title: "See the app in action.",
      subtitle: "45 seconds to understand how Jos'FIT changes your day.",
      badge: "Demo video — coming soon",
      comingSoon: "The demo video is coming very soon. Stay tuned! 🎬",
    },
    scanFridge: {
      overline: "Flagship feature",
      title: "Scan your fridge, AI does the rest.",
      subtitle: "Snap a photo of your fridge (or cupboards): Jos'FIT identifies your foods and instantly suggests balanced meals tailored to your goals.",
      bullets: ["Instant AI food detection", "Meal ideas from what you actually have", "Generate your 7-day menu", "Export your menu to PDF", "Zero waste, optimized shopping", "Add straight to your food journal"],
      premium: "7-day menu generation & PDF export available with the Premium plan (from €1.20/month)",
      cta: "Try the fridge scan",
    },
    byok: {
      overline: "Tutorial · AI key",
      title: "Enable AI with your own Gemini key (BYOK).",
      subtitle: "Use your personal Google Gemini key to unlock the AI Coach. Follow this step-by-step — it takes 2 minutes.",
      freeBadge: "100% free",
      personalBadge: "Personal & private",
      steps: [
        { title: "Open Google AI Studio", desc: "Go to aistudio.google.com/app/apikey and sign in with your Google account." },
        { title: "Create your API key", desc: "Click \"Create API key\", then pick a project or keep the default project." },
        { title: "Copy your key", desc: "Your Gemini key appears (it starts with AIza…). Copy it in one click." },
        { title: "Paste it into Jos'FIT", desc: "Open Profile → Premium BYOK, paste your key and confirm." },
        { title: "You're all set!", desc: "The Luna AI Coach, photo analysis and personalized advice are unlocked." },
      ],
      step: "Step",
      note: "Your Gemini key is free (quota provided by Google) and strictly personal: it stays on your device — Jos'FIT never stores it on its servers.",
      cta: "Get my free Gemini key",
    },
    pricing: {
      overline: "Pricing",
      slogan: "Health tracking that adapts to you — not the other way around.",
      subtitle: "Three clear plans, no commitment. Start free, go Premium whenever you want.",
      perMonth: "/month",
      perYear: "/year",
      billing: { monthly: "Monthly", annual: "Annual", save: "2 months free" },
      guarantee: "No commitment · Cancel anytime · Your data is never sold",
      popular: "Most popular",
      plans: [
        {
          emoji: "🌱",
          name: "Free",
          price: "€0",
          priceAnnual: "€0",
          annualEq: "",
          priceNote: "no commitment, no credit card",
          tagline: "The manual tracking essentials. Because health shouldn't have a price tag.",
          features: [
            "Search 6,000+ foods (available offline)",
            "Macro tracking (protein, carbs, fat, fiber) + calories",
            "Daily meal log (breakfast, lunch, dinner, snack)",
            "Full glucose tracking (readings, trends, hypo/hyper alerts)",
            "Maintenance calculator (BMR + TDEE)",
          ],
          cta: "Start for free",
        },
        {
          emoji: "💎",
          name: "Premium BYOK",
          price: "€1.20",
          priceAnnual: "€12",
          annualEq: "that's €1/mo",
          priceNote: "no commitment",
          badge: "Best value",
          tagline: "All Premium features at a tiny price, using your own free Google Gemini AI key (free from Google — 1,500 requests/day).",
          includes: "Everything in Free, plus:",
          features: [
            "AI Photo → auto meal analysis (macros + Nutri-Score + GI)",
            "AI text analysis (describe your meal → the AI does the math)",
            "Luna Coach: 24/7 nutrition & training AI chat",
            "AI recipe import (photo of a recipe → instant log)",
            "Real-time metabolic cockpit",
            "Smart shopping list",
            "PDF exports (day, week, AGP doctor reports)",
            "Menstrual cycle tracking + hormonal phases",
            "Premium exercise sheets (Sheet 36 & up)",
          ],
          note: "Set up your Gemini key once (2-min guide included) → you stay on Google's free quota, no surprises ever.",
          cta: "Go Premium BYOK",
        },
        {
          emoji: "👑",
          name: "Premium All-in",
          price: "€3.99",
          priceAnnual: "€39.90",
          annualEq: "that's €3.32/mo",
          priceNote: "no commitment",
          badge: "Zero setup",
          tagline: "The simplest experience: you pay, it works. Our AI key included, no setup.",
          includes: "Everything in Premium BYOK, plus:",
          features: [
            "Our Gemini key built right in (zero configuration)",
            "No Google AI account to create, nothing to set up",
            "Priority email support (reply < 24h)",
            "Early access to new AI features",
          ],
          note: "For those who just want it to work.",
          cta: "Go Premium All-in",
        },
      ],
      compareTitle: "Detailed comparison",
      compareCols: ["Feature", "Free", "BYOK · €1.20", "Premium · €3.99"],
      compareRows: [
        { label: "6,000+ food database (offline)", tiers: [true, true, true] },
        { label: "Macro + calorie tracking", tiers: [true, true, true] },
        { label: "Daily meal log", tiers: [true, true, true] },
        { label: "Full glucose tracking", tiers: [true, true, true] },
        { label: "BMR + TDEE calculator", tiers: [true, true, true] },
        { label: "AI Photo (meal analysis)", tiers: [false, true, true] },
        { label: "AI text analysis", tiers: [false, true, true] },
        { label: "Luna Coach (24/7 AI chat)", tiers: [false, true, true] },
        { label: "AI recipe import", tiers: [false, true, true] },
        { label: "Real-time metabolic cockpit", tiers: [false, true, true] },
        { label: "Smart shopping list", tiers: [false, true, true] },
        { label: "PDF exports (day, week, doctor AGP)", tiers: [false, true, true] },
        { label: "Menstrual cycle tracking + phases", tiers: [false, true, true] },
        { label: "Premium exercise sheets", tiers: [false, true, true] },
        { label: "Gemini key included (zero setup)", tiers: [false, false, true] },
        { label: "No Google AI account needed", tiers: [false, false, true] },
        { label: "Priority support < 24h", tiers: [false, false, true] },
        { label: "Early access to new AI features", tiers: [false, false, true] },
      ],
    },
    testimonials: {
      overline: "What they say", title: "What users think.",
      items: [
        { quote: "Finally an app that understands we're not just numbers. Contextual glucose tracking changed my life.", role: "Type 1 diabetic" },
        { quote: "Macros, hydration, sport — it's all there. Clean, fast interface, no ads.", role: "Amateur runner" },
        { quote: "The women's module is incredible. Correlations between cycle and nutrition — I'd never seen that anywhere.", role: "Cycle user" },
      ],
    },
    why: {
      overline: "Why Jos'FIT?", title: "The Jos'FIT difference.",
      reasons: [
        { title: "All-in-one", desc: "Nutrition, metabolic health and body tracking together in a single app." },
        { title: "Premium experience", desc: "Simple, fast and accessible — designed to be used every day without friction." },
        { title: "Personalized AI", desc: "Tailor-made recommendations powered by built-in artificial intelligence." },
      ],
      free: "Free", premium: "Premium from €1.20/month",
      pricingText: "Free app with essential features. Unlock AI and advanced analytics with a Premium subscription from €1.20/month.",
      cta: "Try the app without installing",
    },
    faq: {
      overline: "FAQ", title: "Frequently asked questions.",
      items: [
        { q: "Is the app really free?", a: "Yes, all essential features are free and will stay free. No ads, no data reselling. An optional Premium pack lets you unlock advanced features such as advanced exports and in-depth AI analytics." },
        { q: "Is my health data protected?", a: "Absolutely. Jos'FIT runs 100% locally: your data stays on your phone and is never sent to a server without your explicit consent. Privacy is at the core of the app." },
        { q: "Can I sync my smartwatch?", a: "Yes. Jos'FIT connects to Health Connect, Apple Health as well as Garmin, Fitbit and Polar watches to centralize all your data in one place." },
        { q: "Does the app work offline?", a: "Yes, most features (food journal, glucose, cycle, statistics) are available offline. Optional sync happens as soon as you're back online." },
        { q: "Is there a web version?", a: "Jos'FIT is above all a mobile app for iOS & Android to stay with you every day. A complementary web version to view your reports is being considered." },
        { q: "Is the Google Gemini key really free?", a: "Yes, 100%. Google gives you up to 1,500 requests per day for free — more than enough for daily use. With the BYOK plan you use that free quota: you only pay Jos'FIT's €1.20/month, never Google." },
        { q: "What's the difference between BYOK and All-in?", a: "With BYOK (€1.20) you set up your own Gemini key once (2 min, in-app guide). With All-in (€3.99), our key is already built in: zero configuration, you pay and it just works." },
        { q: "Can I switch plans or cancel anytime?", a: "Of course. All our plans are commitment-free. You can switch between plans or cancel whenever you want, right from the app." },
        { q: "What happens if I exceed my free Gemini quota?", a: "It's very rare: 1,500 requests/day covers heavy use. If you ever hit the limit, the AI simply pauses until the next day — the rest of the app keeps working normally." },
      ],
    },
    download: {
      title: "Ready to take back control of your health?",
      subtitle: "Free download. No credit card. No ads. Just you and your goals.",
    },
    footer: {
      tagline: "Your health & nutrition companion. Made with ❤️ in France.",
      newsTitle: "Stay informed", newsDesc: "Get our health & nutrition tips and the latest app news.",
      placeholder: "Your email address", subscribe: "Subscribe",
      privacy: "Privacy", cgu: "Terms", rights: "All rights reserved",
      subOk: "Subscribed! Thanks for joining us. 🎉", subErr: "Something went wrong. Please try again.",
    },
    launch: {
      limitTitle: "Trial limit reached",
      limitDesc: "You've used your 2 free preview sessions. To keep exploring Jos'FIT, join the official testers 👇",
      expiredTitle: "Trial time is up",
      expiredRemaining: "Your 3-minute trial is over. You have {n} session(s) left. For full access, become a tester:",
      expiredNone: "Your 3-minute trial is over and you've used all your free sessions. Become a tester for full access:",
      testflight: "Join TestFlight (iOS)", android: "Android internal test (by invitation)", contact: "Contact me: contact@josfit.app",
      inProgress: "Trial in progress", popup: "Allow pop-ups to launch the app.",
      launched: "Trial started (3 min) · {n} session(s) left",
    },
  },

  pt: {
    nav: { features: "Funcionalidades", preview: "Visão geral", demo: "Demo", byok: "Tutorial IA", faq: "FAQ", launch: "Abrir o app" },
    hero: {
      badge: "Em teste no iOS & Android",
      titleA: "O teu companheiro de", titleHighlight: "saúde & nutrição", titleB: "no dia a dia.",
      subtitle:
        "Monitorização precisa da glicemia, diário nutricional com IA, bem-estar feminino, partilha dos teus resultados com um coach nutricional e central de saúde unificada — tudo numa só app pensada para a vida real.",
      local: "100% local, os teus dados não saem do teu telemóvel",
    },
    store: {
      iosSub: "Versão de teste · iOS", iosLabel: "Entrar no TestFlight",
      androidSub: "Versão de teste · Android", androidLabel: "Teste interno Play",
      placesLimited: "Vagas limitadas", onInvitation: "Por convite",
    },
    stats: [
      { value: "30 000+", label: "alimentos indexados" },
      { value: "100%", label: "local · privacidade" },
      { value: "7", label: "módulos integrados" },
      { value: "4.8★", label: "avaliação" },
    ],
    features: {
      overline: "Funcionalidades",
      title: "A tua saúde. Uma única app.",
      subtitle: "A Jos'FIT reúne tudo o que precisas para compreender melhor a tua saúde e atingir os teus objetivos.",
      items: [
        { title: "Nutrição inteligente", items: ["Diário alimentar ultra-rápido", "Base alimentar Portfir disponível offline (sem ligação)", "Alimentos de grandes marcas via scanner de código de barras (OpenFood Portugal)", "Mais de 4 milhões de alimentos", "Foto IA das tuas refeições · análise otimizada", "Entrada por voz & criação/importação de receitas por IA", "Cálculo automático de calorias & macros"] },
        { title: "Coach IA integrado", items: ["Análise das tuas refeições", "Conselhos nutricionais personalizados", "Respostas às tuas perguntas de saúde", "Sugestões adaptadas aos teus objetivos"] },
        { title: "Cockpit metabólico", items: ["Calorias consumidas & restantes", "Distribuição proteínas / hidratos / gorduras", "IMC & metabolismo basal", "Gasto energético", "Acompanhamento de objetivos"] },
        { title: "Monitorização corporal", items: ["Evolução do peso", "Fotos antes / depois", "Medidas", "Gráficos de progresso", "Histórico completo"] },
        { title: "Saúde metabólica", items: ["Monitorização da glicemia", "Análise de tendências", "Correlação alimentação / glicemia", "Painel dedicado"] },
        { title: "Luna — bem-estar feminino", items: ["Monitorização do ciclo menstrual", "Sintomas & fases do ciclo", "Conselhos personalizados"] },
        { title: "Sincronização saúde", items: ["Apple Health", "Health Connect (Android)", "Relógios compatíveis"] },
        { title: "Compras inteligentes", items: ["Ativa o modo compras com os alimentos escolhidos do teu diário", "Lista de compras gerada automaticamente", "Organizada por corredor"] },
        { title: "Exportação de dados", items: ["Exportar PDF & CSV", "Cópia local", "Controlo total dos teus dados"] },
        { title: "Privacidade", items: ["Conforme o RGPD", "Dados seguros & locais", "Controlado pelo utilizador", "Sem publicidade"] },
      ],
    },
    steps: {
      overline: "Fácil de usar", title: "O teu percurso em 3 passos.",
      items: [
        { title: "Descarrega e instala", desc: "Grátis na App Store e Google Play. Sem conta para começar, sem cartão de crédito." },
        { title: "Configura em 2 minutos", desc: "Objetivos (peso, calorias, macros), perfil de saúde e ligação opcional ao teu relógio." },
        { title: "Vive simplesmente", desc: "Regista as tuas refeições e glicemia. A app aprende, personaliza-se e torna-se o teu copiloto de saúde." },
      ],
    },
    preview: {
      overline: "Visão geral", title: "Uma interface pensada para a vida real.",
      subtitle: "Cada ecrã foi pensado para te poupar tempo e manter-te motivado a longo prazo. Estes são ecrãs reais da app.",
      screens: [
        { title: "Partilha coaching", desc: "Atalhos para partilhar com o teu coach: PDF diário e semanal, progresso & exportação CSV" },
        { title: "Pesquisa de alimentos", desc: "Base Portfir offline + grandes marcas via código de barras (OpenFood Portugal)" },
        { title: "Adição inteligente", desc: "Scanner, Foto IA, Voz ou manual" },
        { title: "Refeição surpresa", desc: "Ideia de refeição aleatória segundo os teus macros" },
        { title: "Dia & Luna IA", desc: "Previsor de desejos, dicas de ciclo & coach Luna" },
        { title: "Duplicar refeição", desc: "Copia um dia ou uma refeição num toque" },
        { title: "Exportar PDF", desc: "Relatório detalhado diário ou semanal (7 dias)" },
        { title: "Receitas & Import IA", desc: "Descobre, cria e importa uma ficha por foto" },
        { title: "Pontuação de saúde", desc: "Cockpit metabólico, nutrição, fibra, açúcar" },
        { title: "Balanço metabólico", desc: "BMR, TDEE, IMC, tendência & projeção de peso" },
        { title: "Corpo", desc: "Medidas, objetivo de peso & índices de composição" },
        { title: "Balanço do mês", desc: "Dias monitorizados, curva de peso & hidratação" },
        { title: "Bem-estar feminino", desc: "Ciclo, fases, ovulação, menopausa & lembretes" },
        { title: "O meu progresso", desc: "Antes / Depois, e evolução partilhável" },
        { title: "Coach desportivo", desc: "A tua próxima sessão, monitorização corporal & motivação do dia" },
        { title: "Programas de treino", desc: "Ganho muscular, perda de gordura, peso do corpo & rotinas" },
        { title: "Conselhos de alimentação", desc: "Fichas de proteínas, lípidos, hidratos, fibra & equilíbrio" },
        { title: "Lembretes de treino", desc: "Dias de treino & hora — um lembrete suave para seres regular" },
        { title: "Sessão guiada", desc: "Exercício detalhado, séries, cargas & vídeo de técnica" },
        { title: "Cronómetro de descanso", desc: "Descanso entre séries, ±15s & dicas" },
      ],
    },
    video: {
      overline: "Demo", title: "Vê a app em ação.",
      subtitle: "45 segundos para perceber como a Jos'FIT muda o teu dia a dia.",
      badge: "Vídeo demo — em breve",
      comingSoon: "O vídeo de demonstração chega muito em breve. Fica atento! 🎬",
    },
    scanFridge: {
      overline: "Funcionalidade destaque",
      title: "Digitaliza o teu frigorífico, a IA faz o resto.",
      subtitle: "Tira uma foto ao teu frigorífico (ou armários): a Jos'FIT identifica os teus alimentos e sugere instantaneamente refeições equilibradas adaptadas aos teus objetivos.",
      bullets: ["Deteção instantânea de alimentos por IA", "Ideias de refeições com o que realmente tens", "Gera o teu menu de 7 dias", "Exporta o teu menu em PDF", "Zero desperdício, compras otimizadas", "Adiciona diretamente ao teu diário alimentar"],
      premium: "Geração de menu de 7 dias & exportação PDF disponíveis com o plano Premium (desde 1,20 €/mês)",
      cta: "Experimentar o scan do frigorífico",
    },
    byok: {
      overline: "Tutorial · Chave IA",
      title: "Ativa a IA com a tua própria chave Gemini (BYOK).",
      subtitle: "Usa a tua chave Google Gemini pessoal para desbloquear o Coach IA. Segue este passo-a-passo — demora 2 minutos.",
      freeBadge: "100% grátis",
      personalBadge: "Pessoal & privada",
      steps: [
        { title: "Abre o Google AI Studio", desc: "Vai a aistudio.google.com/app/apikey e inicia sessão com a tua conta Google." },
        { title: "Cria a tua chave API", desc: "Clica em « Create API key » (Criar chave API) e escolhe um projeto ou mantém o projeto por defeito." },
        { title: "Copia a tua chave", desc: "A tua chave Gemini aparece (começa por AIza…). Copia-a num só clique." },
        { title: "Cola-a na Jos'FIT", desc: "Abre Perfil → Premium BYOK, cola a tua chave e confirma." },
        { title: "Está pronto!", desc: "O Coach IA Luna, a análise por foto e os conselhos personalizados ficam desbloqueados." },
      ],
      step: "Passo",
      note: "A tua chave Gemini é gratuita (quota oferecida pela Google) e estritamente pessoal: fica no teu dispositivo — a Jos'FIT nunca a guarda nos seus servidores.",
      cta: "Obter a minha chave Gemini grátis",
    },
    pricing: {
      overline: "Preços",
      slogan: "A monitorização de saúde que se adapta a ti — não o contrário.",
      subtitle: "Três planos claros, sem compromisso. Começa grátis, passa a Premium quando quiseres.",
      perMonth: "/mês",
      perYear: "/ano",
      billing: { monthly: "Mensal", annual: "Anual", save: "2 meses grátis" },
      guarantee: "Sem compromisso · Cancela quando quiseres · Os teus dados nunca são vendidos",
      popular: "O mais popular",
      plans: [
        {
          emoji: "🌱",
          name: "Grátis",
          price: "0 €",
          priceAnnual: "0 €",
          annualEq: "",
          priceNote: "sem compromisso, sem cartão de crédito",
          tagline: "O essencial da monitorização manual. Porque a saúde não tem preço.",
          features: [
            "Pesquisa em 6 000+ alimentos (disponível offline)",
            "Tracking de macros (proteínas, hidratos, gorduras, fibra) + calorias",
            "Diário de refeições diário (pequeno-almoço, almoço, jantar, snack)",
            "Monitorização completa da glicemia (medições, tendências, alertas hipo/hiper)",
            "Calculadora de manutenção (BMR + TDEE)",
          ],
          cta: "Começar grátis",
        },
        {
          emoji: "💎",
          name: "Premium BYOK",
          price: "1,20 €",
          priceAnnual: "12 €",
          annualEq: "ou seja 1 €/mês",
          priceNote: "sem compromisso",
          badge: "Melhor relação",
          tagline: "Todas as funções Premium a baixo custo, usando a tua própria chave IA Google Gemini (grátis na Google — 1 500 pedidos/dia).",
          includes: "Tudo do Grátis, mais:",
          features: [
            "Foto IA → análise automática da refeição (macros + Nutri-Score + IG)",
            "Análise IA por texto (descreve a refeição → a IA calcula)",
            "Coach Luna: chat IA de nutrição & treino 24/7",
            "Importação de receita por IA (foto de uma receita → diário instantâneo)",
            "Cockpit metabólico em tempo real",
            "Lista de compras inteligente",
            "Exportações PDF (dia, semana, relatórios médicos AGP)",
            "Monitorização do ciclo menstrual + fases hormonais",
            "Fichas de exercícios premium (Ficha 36 & +)",
          ],
          note: "Configuras a tua chave Gemini uma só vez (guia de 2 min incluído) → ficas no teu quota gratuito da Google, sem surpresas.",
          cta: "Passar a Premium BYOK",
        },
        {
          emoji: "👑",
          name: "Premium Chave Incluída",
          price: "3,99 €",
          priceAnnual: "39,90 €",
          annualEq: "ou seja 3,32 €/mês",
          priceNote: "sem compromisso",
          badge: "Zero config",
          tagline: "A experiência mais simples: pagas e funciona. A nossa chave IA incluída, sem qualquer setup.",
          includes: "Tudo do Premium BYOK, mais:",
          features: [
            "A nossa chave Gemini integrada (zero configuração)",
            "Nenhuma conta Google AI para criar, nada para configurar",
            "Suporte prioritário por email (resposta < 24 h)",
            "Acesso antecipado a novas funções de IA",
          ],
          note: "Para quem só quer que funcione.",
          cta: "Passar a Premium Chave Incluída",
        },
      ],
      compareTitle: "Comparação detalhada",
      compareCols: ["Funcionalidade", "Grátis", "BYOK · 1,20 €", "Premium · 3,99 €"],
      compareRows: [
        { label: "Base 6 000+ alimentos (offline)", tiers: [true, true, true] },
        { label: "Tracking de macros + calorias", tiers: [true, true, true] },
        { label: "Diário de refeições diário", tiers: [true, true, true] },
        { label: "Monitorização completa da glicemia", tiers: [true, true, true] },
        { label: "Calculadora BMR + TDEE", tiers: [true, true, true] },
        { label: "Foto IA (análise de refeição)", tiers: [false, true, true] },
        { label: "Análise IA por texto", tiers: [false, true, true] },
        { label: "Coach Luna (chat IA 24/7)", tiers: [false, true, true] },
        { label: "Importação de receita por IA", tiers: [false, true, true] },
        { label: "Cockpit metabólico em tempo real", tiers: [false, true, true] },
        { label: "Lista de compras inteligente", tiers: [false, true, true] },
        { label: "Exportações PDF (dia, semana, AGP médico)", tiers: [false, true, true] },
        { label: "Ciclo menstrual + fases", tiers: [false, true, true] },
        { label: "Fichas de exercícios premium", tiers: [false, true, true] },
        { label: "Chave Gemini incluída (zero config)", tiers: [false, false, true] },
        { label: "Sem conta Google AI para criar", tiers: [false, false, true] },
        { label: "Suporte prioritário < 24 h", tiers: [false, false, true] },
        { label: "Acesso antecipado a novas funções IA", tiers: [false, false, true] },
      ],
    },
    testimonials: {
      overline: "O que dizem", title: "O que pensam os utilizadores.",
      items: [
        { quote: "Finalmente uma app que percebe que não somos apenas números. A monitorização da glicemia com contexto mudou a minha vida.", role: "Diabético tipo 1" },
        { quote: "Macros, hidratação, desporto — está tudo lá. Interface limpa e rápida, sem publicidade.", role: "Corredor amador" },
        { quote: "O módulo feminino é incrível. As correlações entre ciclo e nutrição, nunca vi isto noutro lado.", role: "Utilizadora ciclo" },
      ],
    },
    why: {
      overline: "Porquê a Jos'FIT?", title: "A diferença Jos'FIT.",
      reasons: [
        { title: "Tudo-em-um", desc: "Nutrição, saúde metabólica e monitorização corporal numa só app." },
        { title: "Experiência premium", desc: "Simples, rápida e acessível — pensada para uso diário sem fricção." },
        { title: "IA personalizada", desc: "Recomendações à medida graças à inteligência artificial integrada." },
      ],
      free: "Grátis", premium: "Premium desde 1,20 €/mês",
      pricingText: "App gratuita com as funções essenciais. Desbloqueia a IA e as análises avançadas com uma subscrição Premium a partir de 1,20 €/mês.",
      cta: "Experimentar a app sem instalar",
    },
    faq: {
      overline: "FAQ", title: "Perguntas frequentes.",
      items: [
        { q: "A aplicação é mesmo gratuita?", a: "Sim, todas as funcionalidades essenciais são gratuitas e continuarão a sê-lo. Sem publicidade, sem revenda de dados. Um pacote Premium (opcional) permite desbloquear funcionalidades avançadas como exportações avançadas e análises de IA aprofundadas." },
        { q: "Os meus dados de saúde estão protegidos?", a: "Absolutamente. A Jos'FIT funciona 100% localmente: os teus dados ficam no teu telemóvel e nunca são enviados para um servidor sem o teu consentimento explícito. A privacidade está no centro da app." },
        { q: "Posso sincronizar o meu relógio?", a: "Sim. A Jos'FIT liga-se ao Health Connect, Apple Saúde e aos relógios Garmin, Fitbit e Polar para centralizar todos os teus dados num só lugar." },
        { q: "A app funciona offline?", a: "Sim, a maioria das funções (diário alimentar, glicemia, ciclo, estatísticas) está disponível offline. A sincronização opcional acontece assim que voltares a ter ligação." },
        { q: "Existe uma versão web?", a: "A Jos'FIT é sobretudo uma app móvel para iOS & Android para estar contigo todos os dias. Uma versão web complementar para consultar os teus relatórios está em estudo." },
        { q: "A chave Google Gemini é mesmo gratuita?", a: "Sim, 100%. A Google oferece até 1 500 pedidos por dia gratuitamente — mais do que suficiente para uso diário. Com o plano BYOK usas esse quota gratuito: pagas apenas os 1,20 €/mês da Jos'FIT, nunca à Google." },
        { q: "Qual a diferença entre BYOK e Chave Incluída?", a: "Com BYOK (1,20 €) configuras a tua própria chave Gemini uma vez (2 min, guia na app). Com Chave Incluída (3,99 €), a nossa chave já está integrada: zero configuração, pagas e funciona." },
        { q: "Posso mudar de plano ou cancelar quando quiser?", a: "Claro. Todos os planos são sem compromisso. Podes mudar de plano ou cancelar quando quiseres, diretamente na app." },
        { q: "O que acontece se exceder o meu quota Gemini gratuito?", a: "É muito raro: 1 500 pedidos/dia cobrem um uso intenso. Se atingires o limite, a IA faz apenas uma pausa até ao dia seguinte — o resto da app continua a funcionar normalmente." },
      ],
    },
    download: {
      title: "Pronto para retomar o controlo da tua saúde?",
      subtitle: "Download gratuito. Sem cartão de crédito. Sem publicidade. Só tu e os teus objetivos.",
    },
    footer: {
      tagline: "O teu companheiro de saúde & nutrição. Feito com ❤️ em França.",
      newsTitle: "Mantém-te informado", newsDesc: "Recebe as nossas dicas de saúde & nutrição e as novidades da app.",
      placeholder: "O teu email", subscribe: "Subscrever",
      privacy: "Privacidade", cgu: "Termos", rights: "Todos os direitos reservados",
      subOk: "Subscrição feita! Obrigado por te juntares a nós. 🎉", subErr: "Ocorreu um erro. Tenta novamente.",
    },
    launch: {
      limitTitle: "Limite de teste atingido",
      limitDesc: "Já usaste as tuas 2 sessões gratuitas da preview. Para continuar a explorar a Jos'FIT, junta-te aos testers oficiais 👇",
      expiredTitle: "Tempo de teste esgotado",
      expiredRemaining: "O teu teste de 3 minutos terminou. Ainda tens {n} sessão(ões). Para acesso completo, torna-te tester:",
      expiredNone: "O teu teste de 3 minutos terminou e usaste todas as sessões gratuitas. Torna-te tester para acesso completo:",
      testflight: "Entrar no TestFlight (iOS)", android: "Teste interno Android (por convite)", contact: "Contacta-me: contact@josfit.app",
      inProgress: "Teste em curso", popup: "Permite os pop-ups para abrir a app.",
      launched: "Teste iniciado (3 min) · {n} sessão(ões) restante(s)",
    },
  },
};
